import { Component, OnInit } from '@angular/core';
@Component({
    templateUrl: 'termsofuse.html',
    styleUrls: ['./../userRegister.component.css']
})
export class TermsOfUseComponent {

}
